import { Button, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LinkNamesPanel from '../linkNamesPanel/LinkNamesPanel'

/**
 * Button component that opens the Link Names Panel
 *
 * @param {String} label - Optional custom button label
 * @param {Object} person - The selected person object
 * @param {Object} field - The field element to link names to
 * @param {Function} onSave - Callback when panel saves changes
 * @param {Function} onCancel - Callback when panel is cancelled
 * @param {Array<{id: string, partitionKey: string}>|Array<String>} linkedPersonIds - Optional. Array of linked person objects [{id, partitionKey}] or person ID strings (for form mode). Pass null/undefined for SLS mode.
 * @param {boolean} disabled - Optional. When true, disables the button.
 * @param {String} description - Optional. Description to show in the panel.
 * @param {boolean} [preselectCurrentPerson=false] - Optional. Just to show the current focused person checked in the list of linked names even if they are not linked. Defaults to false.
 *
 * @returns {JSX.Element}
 */
const LinkNamesButton = ({
  label,
  person,
  field,
  onSave = () => {},
  onCancel = () => {},
  linkedPersonIds = [],
  disabled = false,
  description,
  preselectCurrentPerson = false,
}) => {
  const [t] = useTranslation()
  const viewNamesPanelOverlay = useOverlay()

  return (
    <>
      <Button
        onClick={viewNamesPanelOverlay.handleClick}
        disabled={disabled}
        linkName="ManageLinkedNames"
        data-testid="link-names-button"
      >
        {label || t('linkNamesButton.manageLinkedNames', 'Manage Linked Names on shared field')}{' '}
      </Button>
      {!disabled && (
        <LinkNamesPanel
          overlay={viewNamesPanelOverlay}
          person={person}
          field={field}
          onCancel={onCancel}
          onSave={onSave}
          linkedPersonIds={linkedPersonIds}
          description={description}
          preselectCurrentPerson={preselectCurrentPerson}
        />
      )}
    </>
  )
}

export default LinkNamesButton
